<template>
  <div class="form-item-container" :class="{ 'first-form-item': form_item_order === 0 && layout_mode === 'all_on_one_page' }">
    <div class="text-container">
      <div class="text-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="text-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>
    <div class="text-area-container">
      <textarea rows="5" maxlength="500" minlength="3" spellcheck="true" v-model="userTypedText">
            </textarea>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextInput',
  props: {
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    form_item_order: {
      type: Number,
      default: -1
    },
    layout_mode: {
      type: String,
      default: 'all_on_one_page'
    }
  },
  data() {
    return {
      userTypedText: ''
    }
  },
  methods: {
  }
})
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.form-item-container {

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  align-items: center;
  justify-items: center;
  padding: 2em 5% 2em 5%;
  color: $gorate-secondary;

  .text-container {
    grid-row: 1;
    padding-bottom: 2em;

    .text-primary-language {
      grid-row: 1;
      /* font-size: 3em; */
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .text-secondary-language {
      grid-row: 2;
      /* font-size: 1.5em; */
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

  .text-area-container {
    grid-row: 2;
    width: 100%;
    display: flex;

    justify-content: center;

    textarea {
      width: 95%;
      padding: 2%;
      border: 2px solid $gorate-secondary;
      background-color: $gorate-medium;
      color: white;
      border-radius: 10px;
      resize: none;
    }
  }

}
</style>
